'use client';

import { useEffect } from 'react';

/**
 * 404 beacon (roadmap 1.3): reports the missing path to /api/track-404 once
 * per view of the not-found page. Client-side on purpose — the 404 page HTML
 * may be served from the ISR cache without a server render, but this effect
 * runs on every real view and carries the true referrer.
 *
 * sendBeacon survives immediate navigation away; fetch(keepalive) is the
 * fallback. Rendering nothing, failing silently — a monitor must never make
 * a broken page more broken.
 */
export function Track404() {
  useEffect(() => {
    try {
      const body = JSON.stringify({
        path: window.location.pathname,
        referrer: document.referrer || undefined,
      });
      const sent = navigator.sendBeacon?.('/api/track-404', new Blob([body], { type: 'application/json' }));
      if (!sent) {
        void fetch('/api/track-404', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body,
          keepalive: true,
          credentials: 'omit',
        }).catch(() => {});
      }
    } catch {
      /* never break the 404 page */
    }
  }, []);

  return null;
}

export default Track404;
